export default __webpack_public_path__ + "static/media/unique14.ee870b45.PNG";